import { Component, Prop, Host, h } from '@stencil/core';

/**
 * TODO
 */
@Component({
  tag: 'som-spinner',
  styleUrl: 'som-spinner.scss',
  shadow: true,
})
export class SomSpinner {
  /**
   * This attribute controls the size of the spinner. Possible values are: `"sm"`, `"md"`, `"lg"`, `"xl"`. By default, the spinner will match the font-size of the parent container.
   */
  @Prop() size: 'sm' | 'md' | 'lg' | 'xl';

  render() {
    return (
      <Host class={(this.size ? ' spinner-size-' + this.size : '')} aria-hidden>
        <svg class="spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20"></circle>
        </svg>
      </Host>
    );
  }
}
